import {Alert, ButtonBase, Grid, Typography} from "@mui/material";
import {PaymentCardImg} from "../../views/booking-payment/style";
import PaymentMethodsActionsMenu from "./PaymentMethodsActionsMenu";
import {BankAccountStatus} from "../constants/securspace-constants";
import PaymentMethodListCard from "./PaymentMethodListCard";
import {styled} from "@mui/material/styles";

interface PaymentMethod {
    id: string;
    lastFour: string;
    nickName?: string;
    expiresOn?: string;
    stripePaymentMethodId?: string;
    stripeCustomerId?: string;
    stripeStatus?: string;
    dwollaFundingSourceId?: string;
    dwollaStatus?: string;
}

interface PaymentMethodItemProps {
    paymentMethod: PaymentMethod;
    img: string;
    cardTitle: string;
    verifyPaymentMethod: (paymentMethod: PaymentMethod) => void;
    onMenuAction: (actionName: string, paymentMethod: PaymentMethod) => void;
    disableRemove?: boolean;
}

const PaymentMethodCardInfoContainer = styled(Grid)(() => ({
  gap: '1em',
  alignItems: 'center',
}));

const PaymentMethodItem = ({ paymentMethod, img, cardTitle, verifyPaymentMethod, onMenuAction, disableRemove }: PaymentMethodItemProps) => {

  const paymentNeedsVerification = (paymentMethod: PaymentMethod) => {
    if (paymentMethod.stripePaymentMethodId) {
      return false;
    }
    return (paymentMethod.stripeCustomerId && paymentMethod.stripeStatus === BankAccountStatus.UNVERIFIED) ||
      (paymentMethod.dwollaFundingSourceId && paymentMethod.dwollaStatus === BankAccountStatus.UNVERIFIED);
  };

  const handleVerifyClick = () => {
    verifyPaymentMethod(paymentMethod);
  };

  const handleMenuAction = (actionName: string) => {
    onMenuAction(actionName, paymentMethod);
  };

  return (
    <PaymentMethodListCard>
      <PaymentMethodCardInfoContainer item container alignContent={'center'} xs={12} sm>
        <PaymentCardImg src={img} alt="Payment Card" />
        <Typography variant={'h6'} color={'textPrimary'}>{cardTitle}</Typography>
      </PaymentMethodCardInfoContainer>
      <Grid item xs>
        Last Four: {paymentMethod.lastFour}
      </Grid>
      <Grid item xs>
        {`Nick Name: ${paymentMethod.nickName || 'n/a'}`}
      </Grid>
      {
        paymentNeedsVerification(paymentMethod) ?
          <Grid item xs>
            <ButtonBase onClick={handleVerifyClick}>
              <Typography variant={'h6'} color={'secondary'}>Click here to verify</Typography>
            </ButtonBase>
          </Grid> :
          <Grid item xs>
            {`Exp. ${paymentMethod.expiresOn || 'n/a'}`}
          </Grid>
      }
      <Grid container item xs justifyContent={'flex-end'}>
        <PaymentMethodsActionsMenu
          onSelect={handleMenuAction}
          disableRemove={disableRemove}
        />
      </Grid>
      {
        paymentNeedsVerification(paymentMethod) &&
          <Grid item xs={12}>
            <Alert severity="warning">
              Your new ACH account requires verification. Two small deposits will be made to your account within 1–2 business days. Return here once verified.
            </Alert>
          </Grid>
      }
    </PaymentMethodListCard>
  );
};

export default PaymentMethodItem;
